import $ from "jquery";

import component from "../components";

export function handleDuplicateUser(data) {
    if (data.responseJSON && data.responseJSON.error === "DUPLICATE_USER") {
        const { phone } = data.responseJSON;
        const $input = phone ? $("#phone") : $("#email");
        const handle = phone ? "Phone number" : "Email";

        if (window.authUser) {
            $input.siblings(".help-block").text(`${handle} already in use`);
        } else {
            new component.AuthComponent({
                phone: data.responseJSON.phone,
                email: data.responseJSON.email,
                redirect: window.location.pathname + window.location.search,
            }).render();
        }

        return true;
    }

    return false;
}
